// extracted by mini-css-extract-plugin
export default {"datePickerGroup":"datePicker_datePickerGroup__APSkt","label":"datePicker_label__zq-ZM"};